import CityLocation from "@/components/city-location/CityLocation";
import SearchModal from "@/components/search-modal/SearchModal";
import searchIcon from "@/img/search-icon-latest.svg";

import { useState } from "@wordpress/element";
import { WEATHER_STORE } from "@/store/store";
import { WeatherDispatch, WeatherSelect } from "@/store/type";
import { useDispatch, useSelect } from "@wordpress/data";
import { CityFeature } from "@/schemas/city-schema";
import { LocationType } from "@/types/location-params-type";

import "./style.scss";

export const App = () => {
	const { setMarineLocation } = useDispatch(WEATHER_STORE) as WeatherDispatch;
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const { name_en, stations = [] } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) => {
			const store = select(WEATHER_STORE);

			return {
				...store.getLocationMarine(),
				...store.getMarineStationState(),
			};
		},
	);

	const handleSelectLocation = (value: Pick<CityFeature, "properties">) => {
		const { id, name_ar, name_en } = value.properties;
		setMarineLocation({
			id,
			name_ar,
			name_en,
		});
	};

	return (
		<div className="search-bar-marine">
			<div className="wrapper">
				<CityLocation showCity={false} locationName={name_en} />

				<img
					className="search-bar-img"
					onClick={() => setIsOpen(true)}
					src={searchIcon}
					alt="search icon"
				/>

				<SearchModal
					handleSelectLocation={(value: Pick<CityFeature, "properties">) =>
						handleSelectLocation(value)
					}
					placeholder="Search marine stations"
					locationType={LocationType.MARINE_FORECAST}
					isOpen={isOpen}
					cities={stations}
					showFav={false}
					userPosition={null}
					closeModal={() => setIsOpen(false)}
				/>
			</div>
		</div>
	);
};

export default App;
